/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import StatusIcon from 'modules/common/components/StatusIcon';
import * as actions from '../action';

function BusinessTransactionList({ data, handleActiveBusinessHistory, activeBusinessHistory }) {
  return (
    <React.Fragment>
      {!_.isEmpty(data) ? (
        <React.Fragment>
          <div className="col-12 p-0">
            <div className="container-fluid">
              <div className="row mb-2">
                <div className="col-12 p-0 d-flex align-items-center mb-3">
                  <h3 className="text-nowrap m-0 mr-3">List of Transactions</h3>
                  <div className="text-line-primary" />
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col">Transaction Type</div>
              <div className="col px-0">Due Date</div>
              <div className="col d-flex justify-content-end"><span className="mr-5">Status</span></div>
            </div>
          </div>
          {data.map((item, i) => (
            <div className="col-12 p-0" key={item.id}>
              <div className={`${+activeBusinessHistory === +i ? 'card-gray active' : ''} py-3`} onClick={handleActiveBusinessHistory(i)}>
                <div className="container-fluid">
                  <div className="row">
                    <div className="col">{_.get(item, 'attributes.transaction_type') || '--'}</div>
                    <div className="col px-0">{_.get(item, 'attributes.due_date') || '--'}</div>
                    <div className="col d-flex justify-content-end"><StatusIcon value={_.get(item, 'attributes.transaction_status', '')} size="SM" /></div>
                  </div>
                </div>
              </div>
            </div>
          ))
          }
        </React.Fragment>
      ) : <div className="mb-4" />}
    </React.Fragment>
  );
}

BusinessTransactionList.propTypes = {
  data: PropTypes.instanceOf(Array).isRequired,
  handleActiveBusinessHistory: PropTypes.instanceOf(Function).isRequired,
  activeBusinessHistory: PropTypes.number.isRequired,
};

const mapStateToProps = () => ({
});

const enhance = _.flowRight([
  withRouter,
  connect(
    mapStateToProps,
    actions,
  ),
]);


export default enhance(BusinessTransactionList);
